import { extra6erSlug } from '../../../configs/global';

export default () => ({
  handler: 'relativeUrl',
  data: () => `/${extra6erSlug}`,
});
